// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import TeamsDashboard from '../../components/administration/teams/TeamsDashboard';

const TaxiEquiposPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <TeamsDashboard
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de grupos de equipos de taxi:', newOrder);
                }}
            />
        </Box>
    );
};

export default TaxiEquiposPage;
